// extracted by mini-css-extract-plugin
module.exports = {"Distinte":"Distinte__Distinte__[hash_base64-5]","Title":"Distinte__Title__[hash_base64-5]"};